document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hover-swap-image').forEach(function (img) {
        const normalSrc = img.src;
        const hoverSrc = img.dataset.hover;

        const card = img.closest('.button-block-hover');   // hover on the whole button, not just the image
        const target = card || img;

        target.addEventListener('mouseenter', function () {
            img.src = hoverSrc;
        });
        target.addEventListener('mouseleave', function () {
            img.src = normalSrc;
        });
    })
});